import "./NotFoundPage.scss";

import React, { useEffect } from "react";
import { logToSentry, getSessionId } from "utils/sentry";
import { useSelector } from "utils/redux";

const NotFoundPage = () => {
  const uiSessionId = getSessionId();
  const loggedInUser = useSelector((state) => state.main.loggedInUser);
  const userId = loggedInUser?.id || "unknown";
  const userEmail = loggedInUser?.email || "unknown";

  useEffect(() => {
    logToSentry(`404 Page`, "warn", {
      uiSessionId,
      url: window.location.href,
      userId,
      userEmail,
    });
  }, [loggedInUser, uiSessionId]);

  return (
    <div className="not-found-page">
      <div className="not-found-content">
        <div className="not-found-logo">
          <img className="img" src="/static/images/logo-purple.png"></img>
        </div>

        <div className="error-code">404</div>
        <div className="error-title">Page Not Found</div>
        <p>Oops! The page you're looking for doesn't exist.</p>

        <div className="flex ac-c jc-c">
          <a href="/" className="button undefined">
            Head Back Home
          </a>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
